
import React, { memo } from 'react';
import { isMobile } from "react-device-detect";
import { getMessage } from "CONFIG/i18n";

import calendarSmall from "ASSETS/Images/ic_calendar_small.svg";
import style from './style.module.less';

import { DateRangePicker as RDDateRangePicker } from 'react-dates';
import 'react-dates/initialize';

const Component = ({
  className = '',
  dates,
  onDatesChange,
  focusedInput,
  onFocusChange,
  disabled
}) => 
  <div className={`${style.DateRangePickerContainer} ${className}`}>
    <RDDateRangePicker
      startDateId="startDate"
      endDateId="endDate"
      startDate={dates.startDate}
      endDate={dates.endDate}
      onDatesChange={onDatesChange}
      focusedInput={focusedInput}
      onFocusChange={onFocusChange}
      noBorder
      startDatePlaceholderText={getMessage("FROM")}
      endDatePlaceholderText={getMessage("TO")}
      showDefaultInputIcon
      inputIconPosition="after"
      displayFormat="YYYY/MM/DD"
      monthFormat={getMessage("DATE_PICKER_FORMAT")}
      customInputIcon={<img src={calendarSmall} />}
      customArrowIcon={<div className="px-2">~</div>}
      isOutsideRange={() => false}
      numberOfMonths={isMobile ? 1 : 2}
      hideKeyboardShortcutsPanel
      disabled={disabled}
      minimumNights={0}
    />
  </div>

export const DateRangePicker = memo(Component);
